import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseServiceExt } from "@providers/BaseServiceExt";
import { SportsConstants } from "@sports-utils/index";
import { BehaviorSubject } from "rxjs";
import { first, switchMap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class XStateService extends BaseServiceExt {
  xState$ = new BehaviorSubject<string>("");
  xStateAuthorizationHeader$ = new BehaviorSubject<string>("");
  dataOdds = {
    settings: [
      {
        name: "DefaultMaxSystemForMatchacca",
        value: "100",
      },
    ],
  };

  private getHttpOptions(extraHeaders: Record<string, string> = {}): { observe: string; headers: HttpHeaders } {
    return {
      observe: "response",
      headers: new HttpHeaders({
        "X-State": this.getXState(),
        ...extraHeaders,
      }),
    };
  }

  async startBetslip() {
    await this.loadAuthorization();
    await this.loadInitialXState();
  }

  loadAuthorization() {
    const XStateAuthorization = localStorage.getItem("X-State-Authorization");
    if (!XStateAuthorization) {
      this.loadFreeBetsAuthorization().subscribe((resp) => {
        this.saveAuthorization(resp);
      });
    } else {
      this.saveAuthorization(XStateAuthorization);
    }
  }

  loadInitialXState() {
    const XState = localStorage.getItem("X-State");
    if (!XState) {
      this.loadInitialXStateService()
        .pipe(
          switchMap((resp) => {
            this.saveXState(resp);
            return this.setBetbuilderAccumulator(this.dataOdds);
          }),
        )
        .pipe(first())
        .subscribe((resp) => {
          this.saveXState(resp.headers.get("X-State"));
        });
    } else {
      this.setBetbuilderAccumulator(this.dataOdds)
        .pipe(first())
        .subscribe((resp) => this.saveXState(resp.headers.get("X-State")));
    }
  }

  saveXState(state) {
    if (state && state !== "") {
      this.xState$.next(state);
      localStorage.setItem("X-State", state);
    }
  }

  removeXState() {
    localStorage.removeItem("X-State");
  }

  removeXTicketState() {
    localStorage.removeItem("X-Ticket-State");
  }

  restartXState() {
    this.removeXState();
    this.loadInitialXState();
  }

  restartAll() {
    this.removeAuthorization();
    this.removeXState();
    this.removeXTicketState();
    this.startBetslip();
  }

  getXState() {
    return this.xState$.value || localStorage.getItem("X-State");
  }

  saveAuthorization(state) {
    if (state && state !== "") {
      this.xStateAuthorizationHeader$.next(state);
      localStorage.setItem("X-State-Authorization", state);
    }
  }

  removeAuthorization() {
    localStorage.removeItem("X-State-Authorization");
  }

  getAuthorization() {
    return this.xStateAuthorizationHeader$.value;
  }

  loadInitialXStateService() {
    const licenseType = this.globalVars.licenseType;
    const url: string = `${this.globalVars.URLBASE_BETPLACEMENT}${SportsConstants.InitialXStateUrl}?licenseType=${licenseType}`;
    return this.myGet(url);
  }

  loadFreeBetsAuthorization() {
    const licenseType = this.globalVars.licenseType;
    const url: string = `${this.globalVars.URLBASE_BETPLACEMENT}${SportsConstants.AuthorizationHeaderUrl}?licenseType=${licenseType}`;
    return this.myGet(url);
  }

  setBetbuilderAccumulator(dataOdds) {
    const url = `${this.globalVars.BETSLIPSERVICEBASEURL}${SportsConstants.setBetbuilderAccumulator}`;
    return this.myPost2(url, dataOdds, this.getHttpOptions(), true);
  }
}
